import { render, staticRenderFns } from "./JobInfluencerPricingTable.vue?vue&type=template&id=ff2b814a"
import script from "./JobInfluencerPricingTable.vue?vue&type=script&lang=js"
export * from "./JobInfluencerPricingTable.vue?vue&type=script&lang=js"
import style0 from "./JobInfluencerPricingTable.vue?vue&type=style&index=0&id=ff2b814a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports